export default "__VITE_ASSET__44c2b76b__"